import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import values from 'lodash/values';
import get from 'lodash/get';
import { ButtonWithIcon } from '@els/els-react--button';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import NumberFormatter from '@Utils/NumberFormatter';
import SubstanceHelper from '@Components/Results/services/substance-helper.factory';
import uuid from 'uuid/v4';

import './SubstanceRightHandLinks.scss';

function checkLinkCounts(links) {
  return values(links)?.some((count) => count > 0);
}

function capitalize(string = '') {
  return string.length > 0 ? string[0].toUpperCase() + string.slice(1) : '';
}

function SubstanceRightHandLinks({ metadata, substance }) {
  const links = get(substance, 'links', {});

  const openElementLink = useCallback(
    (type) => {
      const requestParams = {
        hitSetKey: metadata.hitSetKey,
        resultName: metadata.resultName,
        searchId: metadata.searchId || uuid(),
      };
      if (metadata.order) {
        requestParams.order = metadata.order;
      }
      SubstanceHelper.openElementLink(type, substance, requestParams);
    },
    [metadata, substance]
  );

  const renderLink = (count, type) =>
    count > 0 && (
      <ButtonWithIcon
        key={type}
        sprite="ChevronRight"
        type="link"
        linkIconSize="xs"
        iconRight
        className={`substance-right-hand-link e2e-righthand-${type} u-els-margin-bottom-1x`}
        onClick={() => openElementLink(type)}>
        {capitalize(type)} - {NumberFormatter(count)}
      </ButtonWithIcon>
    );

  return checkLinkCounts(links) ? (
    <>
      {renderLink(links.preparationsCount, 'preparations')}
      {renderLink(links.reactionsCount, 'reactions')}
      {renderLink(links.targetsCount, 'targets')}
      {renderLink(links.documentCount, 'documents')}
    </>
  ) : null;
}

SubstanceRightHandLinks.propTypes = {
  metadata: MetadataPropTypesShape,
  substance: PropTypes.shape({
    links: PropTypes.shape({
      preparationsCount: PropTypes.number,
      reactionsCount: PropTypes.number,
      targetsCount: PropTypes.number,
      documentCount: PropTypes.number,
    }),
  }).isRequired,
};

export default SubstanceRightHandLinks;
